import * as React from 'react';

import RangeSlider from '../shared/rangeSlider.jsx';

class testRangeSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validation: new Map(),
            valore: 0
        };
        this.invia = this.invia.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.componentName = "[testRangeSlider.jsx] ";
    }


    inputChangeHandler(e, index) {
        // console.log(this.componentName + ' handleChange id: ' + id + ' value: ' + value);
        if (e !== null && e !== undefined) {
            let obj = {};
            let value = e.target.value;
            let id = e.target.id;
            obj[id] = value;
            this.setState(obj)
        }
    }

    invia() {
        //aggiungere la parte di validazione ... 
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }


        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> valore </h1> ' + this.state.valore);
    }

    validateForm() {
        let validation = new Map();
        let required = ['valore'];
        for (let i = 0; i < required.length; i++) {
            if (this.state[required[i]] === undefined || this.state[required[i]] === '' || this.state[required[i]] === null) {
                validation.set(required[i], 'valore obbligatorio');
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div  >

                <div className="row">
                    <RangeSlider
                        value={this.state.valore}
                        id="valore"
                        unitaMisura="$"
                        onChange={this.inputChangeHandler}
                    >
                    </RangeSlider>

                </div>
                <div className="d-flex justify-content-center my-4">
                    <span className="font-weight-bold blue-text mr-2 mt-1">0</span>
                    <div >
                        <input
                            id="valore"
                            type="range"
                            className="custom-range"
                            min="0" max="5"
                            value={this.state.valore}
                            onChange={this.inputChangeHandler}
                            step="1" />
                    </div>
                    <span class="font-weight-bold blue-text ml-2 mt-1">100</span>
                </div>
                <br></br>
                <div className='range-field'>
                    <input
                        id="valore"
                        type="range"
                        min="0" max="5"
                        value={this.state.valore}
                        onChange={this.inputChangeHandler}
                        step="1" />
                </div>
                <hr />
                <button className="btn btn-info" onClick={this.invia}> Invia </button>
                <div id="log"></div>

                <hr />
                <div className="card  border-light mb-6" >

                    <div className="p-2" >
                        PREMIO
                        <hr className="style-one " />
                    </div>

                    <div className="card-body text-center col-6"  >
                        <div className="progress">
                            <div className={"progress-bar col-12 "} role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                €    <input
                                    id="valore"
                                    type="range"
                                    className="custom-range"
                                    min="0" max="5"
                                    value={this.state.valore}
                                    onChange={this.inputChangeHandler}
                                    step="1" />
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        );
    }
}
export default testRangeSlider;